module.exports = __webpack_public_path__ + "img/018-study.57ab7993.svg";